import JourneyOfferList from '@/components/purchase/journey/JourneyOfferList';
import {
  setSelectedOutboundOfferMapByLegId,
  updateSelectedOutboundOfferMapByLegId,
} from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  outboundDataSelector,
  selectedOutboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useBookingCreation } from '@/hooks/useBookingCreation';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import { GTM_EVENT, trackCustomEvent } from '@/utils/gtm';
import { getDefaultOfferMap } from '@/utils/purchase';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OutboundJourneyOfferList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outboundData = useSelector(outboundDataSelector);
  const inboundData = useSelector(inboundDataSelector);
  const { handleCreatingAndFetchingTripOfferBooking } = useBookingCreation();

  useEffect(() => {
    if (outboundData.selectedJourney) {
      dispatch(
        setSelectedOutboundOfferMapByLegId(
          getDefaultOfferMap(outboundData.selectedJourney)
        )
      );
    }
  }, [dispatch, outboundData.selectedJourney]);

  useEffect(() => {
    if (!outboundData.selectedJourney) {
      navigate('/purchase');
    }
  }, [navigate, outboundData.selectedJourney]);

  return (
    <JourneyOfferList
      title={<TransText i18nKey="selectOutboundFare" />}
      selectedJourney={outboundData.selectedJourney}
      updateSelectedOfferMap={updateSelectedOutboundOfferMapByLegId}
      selectedOfferMapByLegIdSelector={selectedOutboundOfferMapSelector}
      onContinue={() => {
        trackCustomEvent(GTM_EVENT.OUTBOUND_OFFER_CONFIRMED);
        if (inboundData.journeys) {
          return navigate('/purchase/inbound/journey');
        }

        handleCreatingAndFetchingTripOfferBooking();
      }}
      onGoBack={() => navigate(-1)}
    />
  );
};

export default OutboundJourneyOfferList;
